import { render } from "./ShippingBillUpload.vue?vue&type=template&id=500569c5&scoped=true"
import script from "./ShippingBillUpload.vue?vue&type=script&lang=js"
export * from "./ShippingBillUpload.vue?vue&type=script&lang=js"

import "./ShippingBillUpload.vue?vue&type=style&index=0&id=500569c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500569c5"]])

export default __exports__